// Please be careful when adding any script here since this is added in <head>, it will delay the page load
function getUserData() {
    var cookieUser = Cookies.get('apn_user_data');
    if (cookieUser) {
        cookieUser = atob(cookieUser);
        cookieUser = decodeURIComponent(cookieUser);
        try {
            cookieUser = JSON.parse(cookieUser);
        } catch (e) {
            cookieUser = '';
        }
    }
    return cookieUser;
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function checkSubscriptionState() {
    var userData = getUserData();
    var isPreview = window.location.pathname.indexOf('/admin/preview/') !== -1;
    var isBot = /google|facebookexternalhit|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(navigator.userAgent);
    var cookiesIsSubscribed = false;
    var cookiesIsSubscribedString = Cookies.get('subscribed');
    if (cookiesIsSubscribedString) {
        if (cookiesIsSubscribedString.toLowerCase() === 'true') {
            cookiesIsSubscribed = true;
        }
    }
    var inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000);

    //...with FB IA users are redirected to the mobile web version of the locked or metered article, with an extra URL parameter e.g. surface=locked_article
    var fbia = getParameterByName('surface');
    if (fbia === 'locked_article') {
        Cookies.set('instantarticle', fbia, {
            expires: inTwentyMinutes
        });
    }

    var fbia = getParameterByName('instantarticle');
    if (fbia === 'yes') {
        Cookies.set('instantarticle', fbia, {
            expires: inTwentyMinutes
        });
    }

    if (!(isBot || isPreview || Cookies.get('cspbypass') || cookiesIsSubscribed || Cookies.get('norestrict') || (userData && (userData.subscribed || userData.norestrict)))) {
        // only redirect here, subscribe page will take care of the tracking
        Cookies.set('premium_subscription_redirect', true);
        Cookies.set('breach_original_referer', document.referrer);
        Cookies.set('breach_url', window.location.href, {
            expires: inTwentyMinutes
        });
        window.location = "/subscriptions/premium/?original_referrer=" + document.referrer;
    } else {
        document.write('<style type="text/css">body {visibility: visible;}</style>');
    }
}

checkSubscriptionState();
